// Per-campaign landing pages. A visitor who hits the home page with a campaign
// code in the query string (`?ref=` or `?utm_campaign=`) is redirected to that
// campaign's landing page, while attribution is still captured (see
// captureAttributionFromUrl, which runs before the router).
//
// To give a campaign a custom landing: add its code → path here. The path must
// be a real route; add it to `LandingPath` so the redirect stays type-safe.
type LandingPath = '/counter';

export const CAMPAIGN_LANDING_PATHS: Record<string, LandingPath> = {
  // EVO Vegas 2026 → the live signup counter.
  'evo-vegas-2026-90qqwz': '/counter',
};

// Returns the landing path for the given campaign params, or null to stay on
// the home page. `ref` (the campaign code) takes precedence over utm_campaign.
export function resolveCampaignLanding(params: {
  ref?: string;
  utm_campaign?: string;
}): LandingPath | null {
  const code = params.ref ?? params.utm_campaign;
  if (!code) return null;
  return CAMPAIGN_LANDING_PATHS[code] ?? null;
}
